import {
  Facet,
  FacetsAdapterResult,
} from '../../../collaborators/fetch-products/new-contract/types';
import sizeFacetAdapter from './complex';
import simpleFacetAdapter from './simple';
import rangeFacetAdapter from './range';
import orderFacets from './helpers/orderFacets';

export default (facet: Facet[]): FacetsAdapterResult => {
  const simpleFacetData = simpleFacetAdapter(facet);
  const sizeFacetData = sizeFacetAdapter(facet);
  const rangeFacetData = rangeFacetAdapter(facet);

  const facetOptions = orderFacets([
    ...simpleFacetData.facetOptions,
    ...sizeFacetData.facetOptions,
    ...rangeFacetData.facetOptions,
  ]);

  const appliedFacets = facetOptions?.reduce((applied, facet) => {
    if (facet?.name) applied[facet.name] = facet.appliedValues;

    return applied;
  }, {});

  const hasTags = Object.keys(appliedFacets)
    .map((name) => appliedFacets[name])
    .some((applied) => applied.length > 0);

  facetOptions.forEach((facet) => {
    delete facet.appliedValues;
  });

  return {
    appliedFacets,
    facetOptions,
    hasTags,
  };
};
